import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy">
      <h1>{t('Privacy Policy')}</h1>
      <p>{t('privacyPolicyIntro')}</p>
      <p>{t('privacyPolicyDataCollection')}</p>
      <p>{t('privacyPolicyDataUsage')}</p>
      <p>{t('privacyPolicyTransmission')}</p>
      <p>{t('privacyPolicyDataStorage')}</p>
      <p>{t('privacyPolicyRights')}</p>
      <p>{t('privacyPolicyChanges')}</p>
      <p>{t('privacyPolicyContact')}</p>
    </div>
  );
};

export default PrivacyPolicy;
